import {
  ApplicationPayload,
  IApplication,
  IManagedApplication,
  Project,
  ProjectPayload,
} from "src/domains/project/types";
import { apiBaseUrls } from "src/platform/constants/shared-constants";
import API from "src/platform/http/shared-http";

const PROJECT = "/api/v1/projects";
const APPLICATION = "/api/v1/applications";
const CACHE = "/api/v1/cache";
const MANAGED_APPLICATIONS = "/api/v1/managed_applications";

class ProjectService {
  public static async getProject(alias: string): Promise<Project> {
    const api = new API(apiBaseUrls.BACKEND, `${PROJECT}/${alias}`);
    return api.get<Project>();
  }

  public static async getPendingApplications(
    alias: string,
  ): Promise<IApplication[]> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${CACHE}?key=pending_applications&field=${alias}`,
    );
    return api.get<IApplication[]>();
  }

  public static async createApplication(
    projectAlias: string,
    application: ApplicationPayload,
  ): Promise<IApplication> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${APPLICATION}?project_alias=${projectAlias}`,
    );
    return api.post<IApplication>(application);
  }

  public static async getManagedApplications(): Promise<IManagedApplication[]> {
    const api = new API(apiBaseUrls.BACKEND, `${MANAGED_APPLICATIONS}`);
    return api.get<IManagedApplication[]>();
  }

  public static async updateProject(
    alias: string,
    data: ProjectPayload,
  ): Promise<Project> {
    const api = new API(apiBaseUrls.BACKEND, `${PROJECT}/${alias}`);
    return await api.patch<Project>(data);
  }

  public static async deleteProject(alias: string): Promise<void> {
    const api = new API(apiBaseUrls.BACKEND, `${PROJECT}/${alias}`);
    return await api.delete();
  }
}

export default ProjectService;
